module.exports = __webpack_public_path__ + "static/media/loyalty.c7bea6c5.svg";